module.exports = __webpack_public_path__ + "static/media/01 Academy Prog Photos.565ceaf8.JPG";